module.exports = __webpack_public_path__ + "img/address.3f8beec0.svg";